import apiClient from "./axios.config";
import Cookies from "js-cookie";

const vendorsRegister = {
  register: async (vendorData) => {
    try {
      const response = await apiClient.post("/vendor/register", vendorData);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  otpVerify: async (ownerData) => {
    try {
      const { vendorGuid, otp } = ownerData;
      const response = await apiClient.post(
        `/vendor/verify-otp?vendorGuid=${vendorGuid}&otp=${otp}`
      );
      const accessToken = response?.data?.result?.accessToken;
      const role = response?.data?.result?.role;

      if (accessToken) {
        Cookies.set("accessToken", accessToken, { expires: 7 });
      }

      if (role) {
        Cookies.set("userRole", role, { expires: 7 });
      }

      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
  resendOtp: async (ownerData) => {
    try {
      const { vendorGuid } = ownerData;
      const response = await apiClient.post(`/vendor/resend-otp/${vendorGuid}`);
      return response.data;
    } catch (error) {
      throw error.response ? error.response.data : error;
    }
  },
};

export default vendorsRegister;
